import { render, staticRenderFns } from "./CustomerNew.vue?vue&type=template&id=1b53df67&scoped=true"
import script from "./CustomerNew.vue?vue&type=script&lang=js"
export * from "./CustomerNew.vue?vue&type=script&lang=js"
import style0 from "./CustomerNew.vue?vue&type=style&index=0&id=1b53df67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53df67",
  null
  
)

export default component.exports